enum SeriesTypes {
  area = 'area',
  column = 'column',
  line = 'line',
}

export default SeriesTypes;
